import $http from '@/libs/axios'

export default class N8nPagesApi {
  static async getN8nPages(params?: any) {
    return (await $http.get('n8n-pages', { params })).data
  }

  static async getN8nPage(id: number) {
    return (await $http.get(`n8n-pages/${id}`)).data
  }

  static async createN8nPage(data: any) {
    return (await $http.post('n8n-pages', data)).data
  }

  static async updateN8nPage(id: number, data: any) {
    return (await $http.put(`n8n-pages/${id}`, data)).data
  }

  static async deleteN8nPage(id: number) {
    return (await $http.delete(`n8n-pages/${id}`)).data
  }

  static async getN8nPagesHistory(params?: any) {
    return (await $http.get('n8n-posts-history', { params })).data
  }

  static async getN8nPageHistory(id: number) {
    return (await $http.get(`n8n-posts-history/${id}`)).data
  }

  static async createN8nPageHistory(data: any) {
    return (await $http.post('n8n-posts-history', data)).data
  }

  static async updateN8nPageHistory(id: number, data: any) {
    return (await $http.put(`n8n-posts-history/${id}`, data)).data
  }

  static async deleteN8nPageHistory(id: number) {
    return (await $http.delete(`n8n-posts-history/${id}`)).data
  }
}
